/**
 * Defined in:
 *   {@link file://./../../../dxos/echo/metadata.proto}
 */
export var EdgeReplicationSetting;
(function (EdgeReplicationSetting) {
    EdgeReplicationSetting[EdgeReplicationSetting["DISABLED"] = 0] = "DISABLED";
    EdgeReplicationSetting[EdgeReplicationSetting["ENABLED"] = 1] = "ENABLED";
})(EdgeReplicationSetting || (EdgeReplicationSetting = {}));
//# sourceMappingURL=metadata.js.map